/**
 * @desc 分页
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageCategory.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageCategory/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
